import axios, { AxiosResponse } from 'axios';

import { UEFADeclarationGetUrl, UEFADeclarationUrl, UEFADeclarationMatches, APIMSubscriptionKey } from '../../helpers/ConfigSettings';
import { IUEFAFormDocument } from './interfaces/IUEFAForm';

export default class UEFADeclarationService {

    public static submitUEFADeclaration = async (payload: IUEFAFormDocument, callback: (result: string, isSuccess: boolean) => void) => {
        await axios({
            method: 'POST',
            url: encodeURI(UEFADeclarationUrl),
            data: payload,
            headers: { 'Ocp-Apim-Subscription-Key': APIMSubscriptionKey }
        }).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                callback(response.data, true);
            } else {
                callback(response.data, false);
            }
        }).catch((error) => {
            if (error.response !== undefined && error.response !== null) {
                callback(error.response.data, false);
            } else {
                callback('Connection error, please try again', false);
            }
        });
    }

    public static getUEFAOpposition = async (param: string, callback: (result: string, isSuccess: boolean) => void) => {
        await axios({
            method: 'GET',
            url: encodeURI(`${UEFADeclarationGetUrl}?name=${param}`)
        }).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                callback(response.data, true);
            } else {
                callback(response.data, false);
            }
        }).catch((error) => {
            if (error.response !== undefined && error.response !== null) {
                callback(error.response.data, false);
            } else {
                callback('Connection error, please try again', false);
            }
        });
    }


    public static getUEFAOppositionMatches = async (callback: (result: string, isSuccess: boolean) => void) => {
        await axios({
            method: 'GET',
            url: encodeURI(`${UEFADeclarationMatches}`)
        }).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                callback(JSON.stringify(response.data), true);
            } else {
                callback(response.data, false);
            }
        }).catch((error) => {
            if (error.response !== undefined && error.response !== null) {
                callback(error.response.data, false);
            } else {
                callback('Connection error, please try again', false);
            }
        });
    }






}
